import React, { useState } from 'react';
import {
  Tooltip as MuiTooltip,
  SxProps,
  TooltipProps,
  Box,
  ClickAwayListener
} from '@mui/material/';
import deepmerge from '@mui/utils/deepmerge';
import { Theme } from '@mui/system';
import SvgInfoFilled from '../../icons/InfoFilled';
import styles from './styles';

export interface LibTooltipProps extends Partial<TooltipProps> {
  iconEnable?: boolean;
  icon?: React.ReactNode | JSX.Element;
  label: string | React.ReactNode;
  children: React.ReactElement<JSX.Element>;
  baseStyles?: SxProps<Theme>;
  titleStyles?: SxProps<Theme>;
  renderOnTouch?: boolean;
}

function LibTooltip({
  label,
  baseStyles,
  titleStyles,
  icon = <SvgInfoFilled />,
  iconEnable = false,
  renderOnTouch = true,
  ...props
}: LibTooltipProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleTooltip = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };

  const handleClickAway = () => {
    setIsOpen(false);
  };

  return (
    <MuiTooltip
      title={
        <ClickAwayListener onClickAway={handleClickAway}>
          <Box sx={deepmerge(styles.titleStyles, titleStyles)}>
            {iconEnable ? icon : null}
            {label}
          </Box>
        </ClickAwayListener>
      }
      componentsProps={{
        tooltip: {
          sx: deepmerge(styles.base, baseStyles)
        }
      }}
      open={isOpen}
      onOpen={toggleTooltip}
      onClose={toggleTooltip}
      {...props}
    >
      <Box onClick={renderOnTouch ? toggleTooltip : undefined}>
        {props.children}
      </Box>
    </MuiTooltip>
  );
}

export const Tooltips = React.memo(LibTooltip);

export default Tooltips;
